import { getClinicsCity } from '../api/clinics';
import { LocationCards } from '../components/LocationCards';
import { initClinicsMap } from '../components/clinicsMap';

export async function initWherePage() {
  const cards = new LocationCards('.where__locations', { pageSize: 6 });
  const mapEl = document.querySelector('.map__container');

  const map = await initClinicsMap(mapEl, {});
  const city = await getClinicsCity(0);
  const clinics = city.clinics;

  if (map) map.showPlaces(clinics);
  cards.showCards(clinics);

  const select = document.querySelector('.where__select select');
  if (select) {
    select.addEventListener('change', async () => {
      const city = await getClinicsCity(select.value);
      const clinics = city.clinics;
      if (map) map.showPlaces(clinics);
      cards.showCards(clinics);
    });
  }

  console.log('📄 Where page initialized.');
}
